forestControllers.controller('sataqsacioBaratiController', function($scope, dropDownData, $state, UserSettings /*User based settings object saved on server DB*/, Settings, sbDropDownData, dialogs, Server) {

    /**
     * Assign arrays for select menus on $scope.
     *
     */
    for (var d in dropDownData) {
        if (dropDownData.hasOwnProperty(d)) {
            $scope[d] = dropDownData[d];
        }
    }

    for (var d in sbDropDownData) {
        if (sbDropDownData.hasOwnProperty(d)) {
            $scope[d] = sbDropDownData[d];
        }
    }

    console.log('XisSaxeobas: ' + JSON.stringify($scope.xisSaxeobas));

    /**
     * Initialize barati object..
     *
     * This object will hold all user input that is sent to server.
     */
    $scope.barati = {};
    $scope.barati.locations = UserSettings.locations || {};

    //Disabled temporarly
    //$scope.barati.locations.literi = null;
    //$scope.barati.locations.kvartali = null;

    /**
     * Find out if any location is unset.
     */
    $scope.locationMissing = function() {
        $state.go('app.sataqsacio-barati.literi');
    };

    /**
     * Filter DropDown menu items when user changes value.
     */
    $scope.$watchCollection(function () {
        return $scope.barati.locations;
    }, function(newVal, oldVal){

        if($scope.manualUpdate){

            $scope.manualUpdate = false;
            return;
        }

        $scope.updateState().then(function(data){

            $scope.filterDropDowns();

            $scope.saveSettings();

        }).catch(function(data){

            console.log('Prevented', data);

            $scope.barati.locations = oldVal;

            $scope.manualUpdate = true;
        });
    });

    $scope.filterDropDowns = function(){
        /**
         * Filter regionebi based martvis organo
         */
        $scope.regionebiFiltered =
            getListWhere($scope.regionebi, 'martvis_organo_id',
                $scope.barati.locations.martvis_organo_id);

        /**
         * Filter satyeo ubani based regioni
         */
        $scope.satyeoUbnebiFiltered =
            getListWhere($scope.satyeoUbnebi, 'regioni_id',
                $scope.barati.locations.regioni_id);

        /**
         * Filter satye based satyeo ubani
         */
        $scope.satyeoebiFiltered =
            getListWhere($scope.satyeoebi, 'satyeo_ubani_id',
                $scope.barati.locations.satyeo_ubani_id);
    };

    $scope.saveSettings = function(){
        /**
         * Save update selected locations on server.
         */
        UserSettings.locations = $scope.barati.locations;
        Settings.save({'settings' : UserSettings});
    };

    $scope.updateState = function(newVal, oldVal){

        var messages = {
            'martvis_organo_id' : {
                note : 'მართვის ორგანო',
                list : 'regionebi'
            },
            'regioni_id' : {
                note : 'რეგიონი',
                list : 'satyeoUbnebi'
            },
            'satyeo_ubani_id' : {
                note : 'სატყეო უბანი',
                list : 'satyeoebi'
            },
            'satyeo_id' : {
                note : 'სატყეო',
                list : null
            }
        };

        for(var key in messages) {

            /**
             * This bit is really important we check wheter chosen element has
             * children in herarcically next dropdown, and if it have not we
             * should consider that child dropdown models have undefined values too.
             * This happens automatically on next digest after ng-repeat values are
             * replaced by filterDropDowns(), but that is too late.
             */

            var children = 1;
            if(messages[key].list !== null){
                children = getListWhere($scope[messages[key].list], key, $scope.barati.locations[key]).length;
            }

            if(!$scope.barati.locations[key] || !children){
                $scope.note = messages[key].note;
                return $state.go('app.sataqsacio-barati.not-chosen');
            }
        }

        /**
         * If we got here it measn everything is chosen.
         */

        var stateParams = null;

        if($scope.barati.locations.kvartali && $scope.barati.locations.literi){

            stateParams = {
                satyeo_id : $scope.barati.locations.satyeo_id,
                kvartali : $scope.barati.locations.kvartali,
                literi : $scope.barati.locations.literi
            };

            return $state.go('app.sataqsacio-barati.input', stateParams);

        }else if($scope.barati.locations.kvartali && !$scope.barati.locations.literi){

            /**
             * Add kvartali to state parames needed to resolve child liters
             */

            stateParams = {satyeo_id : $scope.barati.locations.satyeo_id, kvartali : $scope.barati.locations.kvartali};

            return $state.go('app.sataqsacio-barati.literi', stateParams);

        }else{

            /**
             * Add satyeo id to state parames needed to resolve child kvartals
             */

            stateParams = {satyeo_id : $scope.barati.locations.satyeo_id};

            return $state.go('app.sataqsacio-barati.kvartali', stateParams);
        }
    };

    /**
     * We need to reset kvartali and literi whenever satyeo_id changes.
     */

    $scope.resetKvartaliAndLiteri = function(){

        /*if($scope.prevented){
            return;
        }*/

        $scope.barati.locations.kvartali = null;
        $scope.barati.locations.literi = null;
    };

    $scope.chooseKvartali = function(){
        if(!$scope.barati.locations.satyeo_id){
            return;
        }
        $state.go('app.sataqsacio-barati.kvartali', {satyeo_id : $scope.barati.locations.satyeo_id});
    };

    $scope.chooseLiteri = function(){
        if(!$scope.barati.locations.kvartali){
            return;
        }
        $state.go('app.sataqsacio-barati.literi', {satyeo_id : $scope.barati.locations.satyeo_id, kvartali : $scope.barati.locations.kvartali});
    };

    $scope.sbDelete = function(id){

        dialogs.confirm("დასტური", "დაადასტურეთ სატაქსაციო ბარათის წაშლა").result.then(function(){
            Server.deleteSb(id).then(function () {
                dialogs.notify("ბარათი წაიშალა", "სატაქსაციო ბარათი წარმატებით წაიშალა");
                $scope.chooseLiteri();
            }).catch(function () {
                dialogs.error("ბარათი ვერ წაიშალა", "შეამოწმეთ ინტერნეტთან კავშირი");
            });
        });
    };
});